<template>
  <div class="tw-w-full tw-border-b tw-border-slate-200/60 tw-bg-white/50 tw-backdrop-blur-md tw-py-3 tw-px-4">
    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-gap-4">
      
      <div class="tw-flex-shrink-0">
        <div class="tw-flex tw-items-center tw-gap-2">
          <h1 class="tw-text-xl tw-font-bold tw-tracking-tight tw-text-slate-800">Tracking</h1>
          <span class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-emerald-700">Live</span>
        </div>
        <div class="tw-text-xs tw-text-slate-500">Manage your fleet in real-time</div>
      </div>

      <div class="tw-flex-1 tw-min-w-0">
        <slot name="search"></slot>
      </div>

      <div class="tw-flex tw-items-center tw-gap-2">
        <Button variant="secondary" @click="$emit('refresh')">
          Refresh
        </Button>
        <Button variant="secondary" @click="$emit('toggleAppointments')" class="tw-whitespace-nowrap">
          {{ !isShowingAppointments ? 'Show appointments' : 'Hide appointments' }}
        </Button>

        <div class="tw-hidden lg:tw-block tw-h-6 tw-w-px tw-bg-slate-200 tw-mx-1"></div>

        <div class="tw-flex-shrink-0">
          <slot name="actions"></slot>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Button from '@/components/core/Button.vue';

export default defineComponent({
  name: 'TrackingHeader',
  components: { Button },
  props: {
    isShowingAppointments: { type: Boolean, required: true },
  },
  emits: ['refresh', 'toggleAppointments'],
});
</script>

<style scoped lang="scss">
</style>
